import { createAction, props } from "@ngrx/store";
import { RoomAccountDeleteCmd } from "@youm-front/room/domain";

export const roomAccountDelete = createAction(
  "[Room] Room Account Delete",
  props<{ roomAccountDeleteCmd: RoomAccountDeleteCmd }>()
);
export const roomAccountDeleteSuccess = createAction(
  "[Room] Room Account Delete Success",
  props<{ roomAccountDeleteCmd: RoomAccountDeleteCmd }>()
);
export const roomAccountDeleteFailure = createAction(
  "[Room] Room Account Delete Failure",
  props<{ error: string }>()
);
